import { useRoot } from '-app/root'

export function useUserModel() {
  const { user } = useRoot()

  return user
}
